import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { TcDirectorySurvivalProgram } from '../_types';
import { classnames } from 'tailwindcss-classnames';
import LinkA11yWrapper from 'components/helpers/LinkA11yWrapper';
import StaffComponent from './StaffComponent';
import PatientEligibilityComponent from './PatientEligibilityComponent';
import { capitalizeFirstLetter } from 'lib/util/strings';
import { TcDirectoryListingClasses } from 'components/authorable/NmdpSite/TcDirectoryListing/_classes';

const SurvivorshipProgramComponent = ({
  fields,
  displayName,
  rendering,
}: TcDirectorySurvivalProgram) => {
  if (!fields) {
    return <MissingDataSource />;
  }
  const state = fields.state?.fields as { Value: { value: string } };
  return (
    <>
      <div className={TcDirectoryListingClasses.SectionWrapper}>
        {displayName && (
          <h2 className={TcDirectoryListingClasses.Heading.Medium}>
            <span className={classnames('inline-block')}>{displayName}</span>
          </h2>
        )}
        <section>
          {fields.addr1?.value && <span className={classnames('pr-2')}>{fields.addr1?.value}</span>}
          {fields.addr2?.value && <span>{fields.addr2.value}</span>}
        </section>
        <section>
          {fields.city?.value && `${fields.city?.value}, `}
          {state?.Value?.value && `${state.Value?.value} `}
          {fields.zip?.value && fields.zip?.value}
        </section>
        {fields.phone?.value && (
          <section>
            <span className={classnames('pr-1')}>Phone:</span>
            {fields.phone.value}
          </section>
        )}
        {fields.refPhone?.value && (
          <section>
            <span className={classnames('pr-1')}>Physician Referrals:</span>
            {fields.refPhone.value}
          </section>
        )}
        {fields.email?.value && (
          <section>
            Email:
            <LinkA11yWrapper
              className={classnames('font-regular', 'pr-4')}
              field={{
                value: { href: `mailto:${fields.email.value}`, text: fields.email.value },
              }}
            />
          </section>
        )}
      </div>
      {fields.website?.value?.href && (
        <div className={TcDirectoryListingClasses.SectionWrapper}>
          For more information about this program:{' '}
          <LinkA11yWrapper
            className={classnames('text-blue-morning', 'underline')}
            field={fields.website}
          />
        </div>
      )}
      {fields?.dscr?.value && (
        <div className={TcDirectoryListingClasses.SectionWrapper}>
          <h2 className={TcDirectoryListingClasses.Heading.Medium}>
            <span className={classnames('inline-block')}>Overview</span>
          </h2>
          <p>{fields.dscr?.value}</p>
        </div>
      )}
      <StaffComponent fields={fields} name="" rendering={rendering} />
      {fields?.specialties?.value && (
        <div className={TcDirectoryListingClasses.SectionWrapper}>
          <h2 className={TcDirectoryListingClasses.Heading.Medium}>
            <span className={classnames('inline-block')}>Medical Specialties in Program</span>
          </h2>
          <div>{capitalizeFirstLetter(fields.specialties.value).replace(/\r\n/g, ', ')}</div>
        </div>
      )}
      {fields?.services?.value && (
        <div className={TcDirectoryListingClasses.SectionWrapper}>
          <h2 className={TcDirectoryListingClasses.Heading.Medium}>
            <span className={classnames('inline-block')}>Medical Services Offered</span>
          </h2>
          <div className={classnames('mb-4')}>
            {capitalizeFirstLetter(fields.services.value).replace(/\r\n/g, ', ')}
          </div>
          <div>Telemedicine services are available.</div>
        </div>
      )}
      {fields?.eligibility && fields.eligibility?.length > 0 && (
        <div className={TcDirectoryListingClasses.SectionWrapper}>
          <h2 className={TcDirectoryListingClasses.Heading.Medium}>
            <span className={classnames('inline-block')}>Patient Eligibility</span>
          </h2>
          {fields.eligibility?.length && <PatientEligibilityComponent {...fields.eligibility[0]} />}
        </div>
      )}
    </>
  );
};

export default SurvivorshipProgramComponent;
